import { keepPreviousData } from '@tanstack/react-query';
import {
    RateOverview,
    RateOverviewFilters,
    useRepositoryQuery,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';
import { TableState } from '@optimus-web/core';

export const useGetQuota = ({ serviceId }: WithServiceId) => useRepositoryQuery('rates', 'getQuota', { serviceId });

export const useGetRatesOverviewEntries = (
    tableState: TableState<RateOverview, RateOverviewFilters>,
    serviceId: string
) =>
    useRepositoryQuery(
        'rates',
        'getOverviewEntries',

        {
            ...tableState,
            serviceId,
        },
        {
            placeholderData: keepPreviousData,
            staleTime: 0,
        }
    );

export const useGetRateDetail = (rateId?: RateOverview['id']) =>
    useRepositoryQuery(
        'rates',
        'getDetail',
        {
            rateId: rateId ?? '',
        },
        {
            placeholderData: keepPreviousData,
            enabled: !!rateId,
        }
    );

export const useSuspenseRateDetailGet = (rateId: RateOverview['id']) =>
    useRepositorySuspenseQuery(
        'rates',
        'getDetail',
        {
            rateId,
        },
        {
            select: ({ options, ...rest }) => ({
                ...rest,
                isBonusPointsEligible: options?.isBonusPointsEligible,
                hidePriceFromGuest: options?.hidePriceFromGuest,
            }),
        }
    );
